import { IAppsByGenre, IAppsStore } from '@stores';

import { EResponseStatus } from '@base/enums';

export function getCompilationVisibility(compilation: IAppsStore | IAppsByGenre ) {
	if (!compilation) {
		return false;
	}

	let appsLength;
	const data = compilation?.data;
	const status = compilation?.status;

	if (data) {
		if ('apps' in data) {
			appsLength = data?.apps?.length;
		} else if ('length' in data) {
			appsLength = data?.length;
		}
	}

	return (
		status === EResponseStatus.PENDING ||
		// status === EResponseStatus.ERROR ||
		(status === EResponseStatus.OK && appsLength)
	);
}
